import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';
import { theme } from '@/theme';

export const FinancingContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${theme.space.s100};
  font-family: ${theme.fontFamilies.openSans};

  /* Mobile styles (default) */
  font-size: ${theme.fontSizes.p2};
  line-height: ${theme.spacing(2.5)};

  img {
    cursor: pointer;
  }

  /* PC styles */
  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        align-items: flex-start;
        font-size: ${theme.fontSizes.p1};
        line-height: ${theme.spacing(2.75)};
      }
    `}
`;

const FinancingTextWrapperBase = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-bottom: ${theme.space.s050};
`;

export const FinancingTextWrapperEn = styled(FinancingTextWrapperBase)`
  flex-direction: column;

  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        flex-direction: row;
      }
    `}
`;

export const FinancingTextWrapper = styled(FinancingTextWrapperBase)`
  flex-direction: row;
  justify-content: center;

  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        justify-content: flex-start;
      }
    `}
`;

export const FinancingText = styled(Typography)`
  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        flex-shrink: 0;
      }
    `}
`;

export const OricoWrapper = styled.div`
  display: flex;
  align-items: center;
`;
